export const ocProps = <T extends Record<string, unknown>>(
  instance: { $ocProps?: T },
  defaultValue = {} as T,
): T => (instance.$ocProps ??= defaultValue);
